import { ActionType } from "../../model/actionTypes";


export const loadUsersAndGroups = (paramsObj :any) =>  async (dispatch: Function, getState: Function, api: any) => {

    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const params = JSON.stringify(paramsObj);
        const resp = await api.get("users/getUsersAndGroups?params="+params);
        dispatch({ type: ActionType.LOAD_GROUP_ATTACHES_SUCCESS, payload: {userList : resp}});
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOAD_GROUP_ATTACHES_FAIL, payload: {} });
        dispatch({ type: ActionType.LOADER, payload: false });
        return [];
    }

}

export const getOdUserGroups = () => async (dispatch: Function, getState: Function, api: any) => {

    dispatch({ type: ActionType.LOADER_GROUPS, payload: true });
    try {
        const resp = await api.get("users/getOdGroups");
        dispatch({ type: ActionType.LOAD_USER_GROUPS_SUCCESS, payload: {groups : resp}});
        dispatch({ type: ActionType.LOADER_GROUPS, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOAD_USER_GROUPS_FAIL, payload: {} });
        dispatch({ type: ActionType.LOADER_GROUPS, payload: false });
        return [];
    }
};

export const createOpenDentalUser = (odUser: any) =>  async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp = await api.post(`users/odUser`, odUser);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch({ type: ActionType.ALERT, payload: err });
        return {};
    }
}

export const updateOpenDentalUser = (odUser: any) =>  async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp = await api.put(`users/odUser`, odUser);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch({ type: ActionType.ALERT, payload: err });
        return {};
    }
}


export const launchFailedRequests = (paramsObj:any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const params = JSON.stringify(paramsObj);
        const resp = await api.get("users/odUsers/reLaunchFailed?params="+params);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        return [];
    }
}